import { AllDriverStatusCount } from "models/AllDriverStatusCount";
import React, { useContext, useState } from "react";

export type AllDriverStatusCountData = [AllDriverStatusCount | undefined, (dispachCount: AllDriverStatusCount) => void];

const AllDriverStatusCountContext = React.createContext<AllDriverStatusCountData>([undefined, () => {}]);

export const AllDriverStatusCountProvider = ({ children }: any) => {
  const [allDriverStatusCount, setAllDriverStatusCount] = useState<AllDriverStatusCount | undefined>(undefined);
  return <AllDriverStatusCountContext.Provider value={[allDriverStatusCount, setAllDriverStatusCount]}>{children}</AllDriverStatusCountContext.Provider>;
};

export const useAllDriverStatusCount = () => {
  return useContext(AllDriverStatusCountContext);
};
